jQuery(function ($) {

  // TextRandomAnimeにappearRandomtextというクラス名を付ける定義
  function TextRandomAnimeControl() {
    $('.TextRandomAnime').each(function () {
      var elemPos = $(this).offset().top - 50;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll >= elemPos - windowHeight) {
        $(this).addClass("appearRandomtext");

      } else {
        $(this).removeClass("appearRandomtext");
      }
    });
  }

  $(window).on('load', function () {
    TextRandomAnimeControl(); /* アニメーション用の関数を呼ぶ*/
  });

});

AOS.init({
  duration: 3000,
  once: true,
});